import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MenuAppConfig, WebApp } from "go-app/services/types";
import NavigationComponentSecurity from "go-security/components/Navigation";
import { NavigationType } from "go-security/components/Navigation/NavigationType";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { selectIsAdmin, selectUser } from "go-security/services/users/selectors";
import { ConfigContext } from "../../services/Config/context";
import { getApiURL } from "../../utils/envutil";
import NavigationOrganizationMenu from "./components/NavigationOrganizationMenu";
import NavigationUserMenu from "./components/NavigationUserMenu";

const Navigation = () => {
	const user = useSelector(selectUser);
	const organization = useSelector(selectOrganization);
	const isAdmin = useSelector(selectIsAdmin);
	const configService = useContext(ConfigContext);
	const applications = configService.applications();
	const baseUrl = getApiURL();
	const { t } = useTranslation();
	const oldStock = applications.find((application) => application.id.toUpperCase() === "GOSTOCK" && application.old);

	const menuAppConfig: MenuAppConfig = {
		webApp: WebApp.GOSTOCK,
		userEnteredLocation: organization.company_id !== undefined,
		oldVersionAppsTimestamp: configService.getAppsOldVersionTimestamps(),
		oldVersionAppsCustomRedirectURL: { GOSTOCK: `${oldStock?.url}/a/${organization.id}` },
	};

	return (
		<NavigationComponentSecurity
			user={user}
			organization={organization}
			apps={applications}
			logo={"/graphics/gostock-logo.svg"}
			logo_small={"/graphics/logo-ico.svg"}
			isAdmin={isAdmin}
			baseUrl={baseUrl}
			menuAppConfig={menuAppConfig}
		>
			<NavigationType
				userNavigation={
					<NavigationUserMenu
						goaccounts_url={configService.getGoAccountsUrl()}
						user={user}
						isAdmin={isAdmin}
					/>
				}
				organizationNavigation={<NavigationOrganizationMenu organization={organization} />}
			/>
		</NavigationComponentSecurity>
	);
};

export default Navigation;
